<template>
  <main style="position: relative">
    <iframe title="SmartAMU (2)"
            ref="BIframe"
            id="BIframe"
            @load="iframeIsLoaded"
            src="https://app.powerbi.com/view?r=eyJrIjoiMmFhZmFjZTEtOTYzNi00MjdiLThhYjQtOGI4MDBhYjMxYjlhIiwidCI6ImFiNjg3ZDEzLTZjMzQtNDdmYi05YWRiLWRlZWI3YzVmNDdjZiIsImMiOjl9"
            allowfullscreen="true" :width="windowWidth" :height="windowHeight" frameborder="0"></iframe>
  </main>
</template>

<script>


export default {
  data() {
    return {
      loading: false,
      loaded: false,
      windowWidth: window.innerWidth - 100,
      windowHeight: window.innerHeight - 50,
      charts: []
    }
  },
  components: {
  },
  methods: {
    iframeIsLoaded () {
      const iframe = document.getElementById("BIframe");
      console.log(iframe.parentNode)

// create the overlay element
      const overlay = document.createElement('div');
      overlay.id = 'overlay';
      overlay.style.position = 'absolute';
      overlay.style.bottom = '0';
      overlay.style.left = '0';
      overlay.style.width = `110%`;
      overlay.style.height = '60px'; // set the height of the overlay to cover the bottom of the iframe
      overlay.style.backgroundColor = '#f7f7f7'; // change this to the desired color
      overlay.style.zIndex = '999'; // make sure this value is higher than the iframe's z-index

// append the overlay element to the parent element of the iframe
      iframe.parentNode.appendChild(overlay);
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth - 100
      this.windowHeight = window.innerHeight - 50


    })
  },
}
</script>
